import { Component, OnInit, ViewChild } from '@angular/core';
import { MapInfoWindow, MapMarker } from '@angular/google-maps';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { CredentialService } from 'src/app/services/core/credential/credential.service';
import { GoogleMap } from '@angular/google-maps';


@UntilDestroy()
@Component({
  selector: 'app-map-view',
  templateUrl: './map-view.component.html',
  styleUrls: ['./map-view.component.css']
})
export class MapViewComponent implements OnInit {
  @ViewChild(GoogleMap) map!: GoogleMap;
  @ViewChild(MapInfoWindow) infoWindow!: MapInfoWindow;
  credentialCompanies: any[] = [];
  selectedCompany: any;
  showMenu = false;
  autoZoom = true;
  showCompanies = true;
  darkMode = false;
  center: google.maps.LatLngLiteral = { lat: 37.7749, lng: -122.4194 };
  zoom = 12;

  constructor(private credentialService: CredentialService) {}

  ngOnInit() {
    this.getCredentialCompanies();
  }

  onMarkerClick(marker: MapMarker, company: any) {
    this.selectedCompany = company;
    this.infoWindow.open(marker);
  }

  getCredentialCompanies() {
    const queryparams = { limit: 9999, isActive: true };

    this.credentialService.getCompanies(queryparams)
      .pipe(untilDestroyed(this)).subscribe((data: any) => {
        if (data && data.results) {
          this.credentialCompanies = data.results.map((company: any) => {
            const coords = company.address?.coords;
            return {
              ...company,
              address: {
                ...company.address,
                coords: {
                  lat: coords[1],
                  lng: coords[0]
                }
              },
              markerOptions: {
                icon: company.profileImageURL
                  ? {
                      url: company.profileImageURL,
                      scaledSize: new google.maps.Size(40, 40)
                    }
                  : undefined
              }
            };
          });

          if (this.autoZoom && this.credentialCompanies.length && this.map) {
            this.fitMapToCompanies();
          }
        }
      });
  }

  fitMapToCompanies() {
    const bounds = new google.maps.LatLngBounds();
    this.credentialCompanies.forEach((c: any) => {
      if (c.address?.coords?.lat && c.address?.coords?.lng) {
        bounds.extend(c.address.coords);
      }
    });
    this.map.googleMap?.fitBounds(bounds);
  }

  toggleAutoZoom() {
    if (this.autoZoom && this.credentialCompanies.length) {
      this.fitMapToCompanies();
    }
  }

  // onCompanyChange(){

  // }
}



